module.exports = __webpack_public_path__ + "static/media/Nunito-Light.18a81d43.ttf";